import {
  SET_BC3_LINK_STATE,
  SET_NEW_MODAL_PART_STATE,
  WRAPPER_MODALS,
} from "context/types"

const initialState = {
  newModalPart: {
    open: false,
    setProperty: () => {},
    from: "wrapper modals",
    chapterId: null,
    partida: null,
    bancoDePrecios: "",
    srcPage: "",
  },
  bc3Link: {
    from: WRAPPER_MODALS,
    open: false,
    setProperty: () => {},
    chapterId: null,
    data: null,
  },
}

const WrapperModalsReducer = (state, action) => {
  switch (action.type) {
    case SET_NEW_MODAL_PART_STATE: {
      return {
        ...state,
        newModalPart: {
          ...state.newModalPart,
          ...action.payload, // Mezcla las propiedades enviadas en el payload con el estado actual
        },
      }
    }
    case SET_BC3_LINK_STATE: {
      return {
        ...state,
        bc3Link: {
          ...state.bc3Link,
          ...action.payload,
        },
      }
    }
    default:
      return state
  }
}

export { initialState, WrapperModalsReducer }
